import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const AutocompleteResults = styled.div`
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.colors.on[100]};
  border-radius: ${({ theme }) => theme.radii.lg}px;
  background-color: ${({ theme }) => theme.colors.secondary[0]};
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.spacing(2)}px);
  padding: ${({ theme }) => theme.spacing(2)}px;
  width: 100%;
`;

export const AutocompleteResultsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
